import React from "react";
import { Siren, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

export const EmergencyBanner = () => {
  return (
    <div data-testid="emergency-banner" className="bg-[#D86C1E]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-2.5 flex items-center justify-center gap-3 text-center">
        <Siren className="h-4 w-4 text-white shrink-0 animate-pulse" />
        <span className="text-white text-xs sm:text-sm font-semibold tracking-wide">
          Roof emergency? Schuyler is available <span className="font-black">24/7</span> —
        </span>
        <a
          href={`tel:${CONTACT.phoneRaw}`}
          data-testid="emergency-call-link"
          className="inline-flex items-center gap-1.5 text-white font-heading font-black text-xs sm:text-sm underline underline-offset-2 hover:text-black transition-colors"
        >
          <Phone className="h-3.5 w-3.5" /> {CONTACT.phone}
        </a>
      </div>
    </div>
  );
};

export default EmergencyBanner;
